import { call, put, select, takeEvery } from "redux-saga/effects";

// Chat Redux States
import {
  ADD_OFFER_HISTORY,
  ADD_OFFER_TRACKER,
  DELETE_OFFER,
  DELETE_OFFER_HISTORY,
  DELETE_OFFER_TRACKER,
  GET_OFFER_BY_ID,
  GET_OFFER_DATA,
  GET_OFFER_HISTORY_LIST,
  GET_OFFER_TRACKER_LIST,
  GET_OFFERS,
  GET_OFFERS_FOR_CLIENT,
  GET_OFFERS_WITH_REGULAR_MATCHING,
  GET_TRACKER_OFFER_PROFILE,
  GET_TRACKERS,
  POST_OFFER,
  UPDATE_OFFER,
  UPDATE_OFFER_STATUS,
  UPDATE_TRACKER_OFFER_PROFILE,
  GET_OFFERS_BY_CONTRACT
} from "./actionTypes";
import {
  getOfferTrackersList,
  hideOfferDataLoader,
  hideOfferLoader,
  hideOffersWithRegularMatchingLoader,
  hideOfferTrackersListListLoader,
  hideTrackersLoader,
  setErrorTrackerOfferProfile,
  setOffer,
  setOfferData,
  setOfferHistoryItem,
  setOfferHistoryList,
  setOffers,
  setOffersByContract,
  setOffersForClient,
  setOffersRentForClient,
  setOffersWithRegularMatching,
  setOfferTrackersList,
  setTrackerOfferProfile,
  setTrackers,
  showOfferDataLoader,
  showOfferLoader,
  showOffersByContractLoader,
  showOffersWithRegularMatchingLoader,
  showOfferTrackersListLoader,
  showTrackersLoader,
} from "./actions";

import {
  deleteOfferById,
  deleteOfferHistory,
  deleteTrackers,
  getHistory,
  getOfferById,
  getOfferData,
  getOffersByContractorId,
  getOffersForClient,
  getOffersList,
  getOffersWithRegularMatching,
  getTrackerOfferProfile,
  getTrackers,
  patchOfferById,
  patchOfferStatus,
  postOffer,
  postTrackers,
  putTrackerOfferProfile,
} from "../../helpers/jwt_helper";

import {
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";

function* onGetOffersForClient({ payload: { id, data } }) {
  try {
    yield put(showOfferDataLoader());
    let dt = {
      page: data.page || 1,
      size: data.sizePerPage || 10,
      is_main: true || data?.is_main,
      // ordering: data.ordering || ''
    };

    if (id) dt.app__client = id;
    if (data?.my_client) dt.my_client = data.my_client;
    if (data?.is_rent == true || data?.is_rent == false) dt.is_rent = data.is_rent;

    let response = yield call(getOffersForClient, dt, data.ordering);
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
        created_at: new Date(i.created_at).toDateString(),
      })),
    };

    if (data?.is_rent == true || data?.is_rent == false) {
      if (data?.is_rent) {
        yield put(setOffersRentForClient(response))
      } else {
        yield put(setOffersForClient(response));
      }
    } else {
      yield put(setOffersForClient(response));
    }
    yield put(hideOfferDataLoader());
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hideOfferDataLoader());
  }
}

function* onGetOffers({ payload: { data } }) {
  try {
    const params = {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      client: data.client,
      search: data.search,
      is_main: data?.is_main,
    };
    yield put(showOfferDataLoader());
    let response = yield call(getOffersList, params);

    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
          created_at: new Date(i.created_at).toDateString(),
        })),
      };
    } else {
      response = {
        results: response,
      };
    }

    yield put(setOffers(response));
    yield put(hideOfferDataLoader());
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(hideOfferDataLoader());
  }
}

function* onGetOfferData({ payload: data = {} }) {
  try {
    yield put(showOfferDataLoader());
    let dt = {
    }
    
    if (data.app) dt.app = data.app;
    if (data?.client_id) dt.client_id = data.client_id;
    if (data?.my_client) dt.my_client = data.my_client;

    let response = yield call(getOfferData, dt);

    response.applications = response.applications.map(i => ({
      label: i.name,
      value: i.id,
      app_id: i.app_id,
    }));
    response.media_sources = response.media_sources.map(i => ({
      label: i.name,
      value: i.id,
    }));
    response.users = response.users.map(i => ({ label: i.email, value: i.id }));
    response.formulas = response.formulas.map(i => ({
      label: i.formula,
      value: i.id,
    }));

    response.currencies = response.currencies.map(i => ({
      label: i,
      value: i,
    }));

    yield put(setOfferData(response));
    yield put(hideOfferDataLoader());
  } catch (error) {
    yield put(hideOfferDataLoader());
  }
}

function* onGetTrackers({ payload: data = {} }) {
  try {
    yield put(showTrackersLoader());
    let response = yield call(getTrackers, {
      offer: data.offer,
    });

    yield put(setTrackers(response));
    yield put(hideTrackersLoader());
  } catch (error) {
    yield put(hideTrackersLoader());
  }
}

function* onPostOffer({ payload: { data, history } = {} }) {
  try {
    // yield put(showTrackersLoader())
    yield put(showOfferLoader());
    let response = yield call(postOffer, data);
    yield put(setOffer(response));
    history?.push(`/offers/${response.id}`, { was_created: true });
    yield put(hideOfferLoader());
    showSuccessMessage("Offer created successfully!");
    return response;
    // yield put(hideTrackersLoader())
  } catch (error) {
    // yield put(hideTrackersLoader())
    yield put(hideOfferLoader());
    showErrorMessage(error);
  }
}

function* onAddOfferHistory({ payload: { data } }) {
  try {
    const current_offer = yield select(state => state.Offers.offer);
    window.history.replaceState({ add_to_history: true }, "");
    const new_offer = yield onPostOffer({
      payload: {
        data: {
          ...data,
          parent_id: current_offer.id,
          main_parent_id: current_offer.main_parent_id || current_offer.id,
        },
      },
    });
    if (!new_offer) return void 0;
    // const historyData = yield select(state => state.Offers.historyData)
    // yield put(setOfferHistoryList([new_offer, ...historyData]))
    // TODO: replace request on FE changes after fixed date range on BE
    yield onGetOfferHistoryList({ payload: new_offer.id });
  } catch (e) {
    console.error(e);
    showErrorMessage(e);
  }
}

function* onDeleteOfferHistory({ payload: id }) {
  try {
    const current_offer = yield select(state => state.Offers.offer);
    const historyData = yield select(state => state.Offers.historyData);
    const history_item = yield select(state => state.Offers.history_item);

    if (historyData.length <= 1) return void 0; // Can't delete last offer history

    const new_historyData = historyData.filter(i => i.id !== id);

    const res = yield call(deleteOfferHistory, id);
    // console.log({ res });

    if (current_offer.id === id) {
      // Deleting main offer from history

      yield put(setOffer(res));

      // yield onGetOfferById({ payload: { id: new_historyData[0].id, need_current_offer: true } });
      // new_historyData[0].date_to = 'Present'
    } else {
      // Deleting another history which != current offer
    }

    // console.log(new_historyData);

    yield put(setOfferHistoryList(new_historyData));

    // console.log({ id, current_offer, historyData, history_item });
  } catch (e) {
    showErrorMessage(e);
  }
}

function* onGetOfferById({
  payload: { id, history, need_current_offer = false },
}) {
  try {
    let response = yield call(getOfferById, id, { need_current_offer });
    response.change_description =
      response.change_description || "No description";

    if (need_current_offer) {
      yield put(setOffer(response));
    } else {
      yield put(setOfferHistoryItem(response));
    }
    return response;
  } catch (error) {
    showErrorMessage(error);
    history?.push("/404");
  }
}

function* onUpdateOfferById({ payload: { id, data, callback = () => {} } }) {
  try {
    let response = yield call(patchOfferById, { id, data });

    const current_offer = yield select(state => state.Offers.offer);

    if (current_offer?.id === id) {
      yield put(setOffer(response));
    } else {
      yield put(setOfferHistoryItem(response));
    }

    // yield put(setOffer(null))
    callback && callback();
    showSuccessMessage("Offer updated successfully!");
    // yield put(hideTrackersLoader())
  } catch (error) {
    // yield put(hideTrackersLoader())
    showErrorMessage(error);
  }
}

function* onUpdateOfferByIds({
  payload: { id, ids, data, callback = () => {} },
}) {
  try {
    yield put(showOfferLoader());
    yield call(patchOfferStatus, {
      offer_ids: ids,
      status: data.status,
    });
    callback && callback();
    yield call(onGetOfferById, {
      payload: {
        id: id,
        history: "",
        need_current_offer: true,
      },
    });
    showSuccessMessage("Offer status changed successfully!");
    yield put(hideOfferLoader());
  } catch (error) {
    yield put(hideOfferLoader());
    showErrorMessage(error);
  }
}

function* onDeleteOfferById({ payload: { id, onRedirectToClient } }) {
  try {
    yield put(showOfferLoader());
    yield call(deleteOfferById, id, true);
    showSuccessMessage("Offer has been deleted");
    yield put(hideOfferLoader());
    onRedirectToClient();
    yield put(setOffer(null));
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetOfferHistoryList({ payload: id }) {
  try {
    let response = yield call(getHistory, id);
    // response = response.map(i => ({...i, change_description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. At eaque est impedit ipsum iste magnam natus odit quia voluptatem! Delectus quam quos ullam veniam voluptate. Eum maiores reiciendis repellendus voluptate!"}))
    response = response.map(i => ({
      ...i,
      change_description: i.change_description || "No description",
    }));
    yield put(setOfferHistoryList(response.reverse()));
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetContractOffers({ payload: data }) {
  try {
    yield put(showOffersByContractLoader());
    let response = yield call(getOffersByContractorId, {
      ...data,
    });
    yield put(setOffersByContract(response));
    yield put(showOffersByContractLoader());
  } catch (error) {
    yield put(showOffersByContractLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetOfferTrackersList({ payload: data, id }) {
  try {
    yield put(showOfferTrackersListLoader());
    let response = yield call(getTrackers, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
      offer: id,
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
        description: i.description === "string" ? "" : i.description,
      })),
    };
    yield put(setOfferTrackersList(response));
    yield put(hideOfferTrackersListListLoader());
  } catch (error) {
    yield put(hideOfferTrackersListListLoader());
    // showErrorMessage(getErrorMessage(error));
  }
}

function* onAddOfferTracker({ payload: { tracker, data } }) {
  try {
    yield put(showOfferTrackersListLoader());
    yield call(postTrackers, {
      offer: tracker.offer,
      tracking_link: tracker.trackingLink,
      tracking_platform: tracker.trackingPlatform,
    });
    yield put(getOfferTrackersList(data, tracker.offer));
    yield put(hideOfferTrackersListListLoader());
    showSuccessMessage("Offer's tracker has been added");
  } catch (error) {
    yield put(hideOfferTrackersListListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteOfferTracker({ payload: { id, data, offer_id } }) {
  try {
    yield put(showOfferTrackersListLoader());
    yield call(deleteTrackers, id);
    yield put(getOfferTrackersList(data, offer_id));
    yield put(hideOfferTrackersListListLoader());
    showSuccessMessage("Offers tracker has been deleted");
  } catch (error) {
    yield put(hideOfferTrackersListListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetTrackerOfferProfile({ payload: id }) {
  try {
    yield put(setErrorTrackerOfferProfile(false));
    let response = yield call(getTrackerOfferProfile, id);
    yield put(setTrackerOfferProfile(response));
  } catch (error) {
    if (getErrorMessage(error) === "Not found.") {
      yield put(setErrorTrackerOfferProfile(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
  }
}

function* onUpdateTrackerOfferProfile({ payload: { id, tracker, data } }) {
  try {
    yield put(showOfferTrackersListLoader());
    yield call(putTrackerOfferProfile, id, {
      offer: tracker.offer,
      tracking_link: tracker.trackingLink,
      tracking_platform: tracker.trackingPlatform,
    });
    yield put(getOfferTrackersList(data, tracker.offer));
    yield put(hideOfferTrackersListListLoader());
    showSuccessMessage("Offers tracker has been updated");
  } catch (error) {
    yield put(hideOfferTrackersListListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetOffersWithRegularMatching({ payload }) {
  try {
    yield put(showOffersWithRegularMatchingLoader());
    const res = yield call(getOffersWithRegularMatching, payload);

    /*const parseOffersWithRegularMatching = data => {
      /!* offers_without_platform_data
       * offers_without_trackers_data
       * offers_without_trackers_cohort_data
       * offers_without_trackers_events_data
       *!/
      // eslint-disable-next-line no-undef
      // const multiple_offers_id = new Set()
      // eslint-disable-next-line no-undef
      const all_offers_id = new Set();

      const offers_without_platform_data =
        data?.offers_without_platform_data?.map(i => ({
          ...i,
          error_type: "platform_data",
        })) || [];
      const offers_without_trackers_data =
        data?.offers_without_trackers_data?.map(i => ({
          ...i,
          error_type: "trackers_data",
        })) || [];
      const offers_without_trackers_cohort_data =
        data?.offers_without_trackers_cohort_data?.map(i => ({
          ...i,
          error_type: "trackers_cohort_data",
        })) || [];
      const offers_without_trackers_events_data =
        data?.offers_without_trackers_events_data?.map(i => ({
          ...i,
          error_type: "trackers_events_data",
        })) || [];
      const all_data = [].concat(
        offers_without_platform_data,
        offers_without_trackers_data,
        offers_without_trackers_cohort_data,
        offers_without_trackers_events_data
      );
      const result = [];

      all_data.forEach(i => {
        if (all_offers_id.has(i.id)) {
          // multiple_offers_id.add(i.id)
          const findItem = result.find(el => el.id === i.id);
          findItem.without[i.error_type] = true;
        } else {
          result.push({
            id: i.id,
            name: i.name,
            date_from: i.date_from,
            without: {
              platform_data: false,
              trackers_data: false,
              trackers_cohort_data: false,
              trackers_events_data: false,
              [i.error_type]: true,
            },
          });
        }

        all_offers_id.add(i.id);
      });

      return result;
    };

    const data = parseOffersWithRegularMatching(res);*/

    // console.log({ data, res });

    // const data = res.offers_without_trackers_cohort_data

    yield put(setOffersWithRegularMatching(res));
    yield put(hideOffersWithRegularMatchingLoader());
  } catch (e) {
    yield put(hideOffersWithRegularMatchingLoader());
  }
}

function* offersSaga() {
  yield takeEvery(GET_OFFERS_FOR_CLIENT, onGetOffersForClient);
  yield takeEvery(GET_OFFER_DATA, onGetOfferData);
  yield takeEvery(GET_TRACKERS, onGetTrackers);
  yield takeEvery(POST_OFFER, onPostOffer);
  yield takeEvery(ADD_OFFER_HISTORY, onAddOfferHistory);
  yield takeEvery(DELETE_OFFER_HISTORY, onDeleteOfferHistory);
  yield takeEvery(GET_OFFER_BY_ID, onGetOfferById);
  yield takeEvery(UPDATE_OFFER, onUpdateOfferById);
  yield takeEvery(UPDATE_OFFER_STATUS, onUpdateOfferByIds); // timeless func
  yield takeEvery(GET_OFFERS, onGetOffers);
  yield takeEvery(DELETE_OFFER, onDeleteOfferById);
  yield takeEvery(GET_OFFER_HISTORY_LIST, onGetOfferHistoryList);
  yield takeEvery(GET_OFFER_TRACKER_LIST, onGetOfferTrackersList);
  yield takeEvery(DELETE_OFFER_TRACKER, onDeleteOfferTracker);
  yield takeEvery(ADD_OFFER_TRACKER, onAddOfferTracker);
  yield takeEvery(GET_TRACKER_OFFER_PROFILE, onGetTrackerOfferProfile);
  yield takeEvery(UPDATE_TRACKER_OFFER_PROFILE, onUpdateTrackerOfferProfile);
  yield takeEvery(
    GET_OFFERS_WITH_REGULAR_MATCHING,
    onGetOffersWithRegularMatching
  );
  yield takeEvery(GET_OFFERS_BY_CONTRACT, onGetContractOffers);
}

export default offersSaga;
